/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconHeadphones(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 8.289a8 8 0 1 1 14.77 4.263l-.913 1.583A2.291 2.291 0 1 1 9.89 11.84l1.212-2.09A2.31 2.31 0 0 1 13.1 8.6h1.392a6.5 6.5 0 1 0-12.985 0h1.39a2.31 2.31 0 0 1 1.999 1.15l1.212 2.09a2.291 2.291 0 1 1-3.966 2.295l-.915-1.585A7.955 7.955 0 0 1 0 8.289zm1.755 1.81c.172.594.426 1.151.749 1.662l.008.013.93 1.611a.791.791 0 1 0 1.37-.792L3.6 10.503a.81.81 0 0 0-.702-.403H1.755zm12.49 0H13.1a.81.81 0 0 0-.7.405l-1.213 2.089a.791.791 0 1 0 1.37.792l.929-1.61.008-.012c.324-.511.578-1.07.75-1.663z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M.5 12.5C.5 6.149 5.649 1 12 1s11.5 5.149 11.5 11.5a11.433 11.433 0 0 1-1.768 6.13l-1.325 2.294a3.232 3.232 0 1 1-5.594-3.238l1.83-3.155a3 3 0 0 1 2.595-1.494h2.247a9.5 9.5 0 1 0-18.97 0H4.76a3 3 0 0 1 2.595 1.494l1.831 3.155a3.232 3.232 0 1 1-5.594 3.238l-1.327-2.298A11.435 11.435 0 0 1 .5 12.5zm2.342 2.537c.25.907.633 1.76 1.125 2.537l.01.017 1.348 2.333a1.232 1.232 0 1 0 2.132-1.234l-1.83-3.155a1 1 0 0 0-.866-.498H2.842zm18.316 0h-1.92a1 1 0 0 0-.864.498l-1.831 3.155a1.232 1.232 0 1 0 2.132 1.234l1.345-2.33.011-.017a9.448 9.448 0 0 0 1.127-2.54z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconHeadphones is deprecated and will be archived soon. Use IconHeadphones instead.
 */
export function Experimental__IconHeadphones(props) {
  return /*#__PURE__*/React.createElement(IconHeadphones, props);
}